"use client";

import { ExternalLink } from "lucide-react";
import hmLogo from "../../src/images/hm_logo.webp";
import "./../components/RebrandBanner.css";

export default function RebrandBadge({ className = "" }) {
  return (
    <div
      className={`rebrand-badge ${className}`}
      role="note"
      aria-label="Rebranding notice"
    >
      {/* Logo + House Master text */}
      <span className="rebrand-logo-section">
        <img
          src={hmLogo}
          alt="House Master logo"
          width={16}
          height={16}
          className="rebrand-logo"
        />
        <span>
          <span className="rebrand-house">House</span>
          <span className="rebrand-master">Master</span>
        </span>
      </span>

      <span className="rebrand-connector">is now</span>

      {/* EzeeTask name */}
      <span className="rebrand-ezeetask">EzeeTask</span>

      {/* Learn more link */}
      <a
        href="https://ezeetask.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="rebrand-link"
        aria-label="Learn more at housemaster.in"
      >
        <ExternalLink className="rebrand-icon" />
      </a>
    </div>
  );
}
